import { $fetch } from '@block/utils';
import { Modal, notification } from '@ss/mtd-react';

// 执行交互
const doAction = async <T = any>(url, param?: DefaultAny, args?: DefaultAny, showError = true): Promise<T> => {
  try {
    args = args || {};
    if (window.location.href.includes('fromMRN') && window.location.href.includes('token')) {
      args.headers = {
        'access-token': window.location.href.split('&token=')[1],
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      };
    } else {
      args = args || {};
    }
    const res = await $fetch(url, param, args);
    return res;
  } catch (err) {
    if (err.errorCode === 401) {
      Modal.info({
        title: '登录信息失效啦，请重新登录',
        okBtnProps: { type: 'primary' },
        okText: '确定',
        onOk: async () => {
          // const { hash } = window.location;
          // const arr = hash.split('/');
          const tenantUid = 1;
          window.location.hash = `#/candidate/${tenantUid}/login`;
        },
      });
    } else if (showError) {
      notification.error({
        title: '错误',
        message: err.message || '操作失败,稍后重试',
      });
    }
    return undefined;
  }
};

export default doAction;
